module.exports = __webpack_public_path__ + "static/media/t01kz.26f58fc2.pdf";